























//状態監視用にwatchを追加 issue:724
import { Component, Emit, Mixins, Prop, Watch } from 'vue-property-decorator'

import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-blue.css'
import { AgGridVue } from 'ag-grid-vue'
import {
  GridOptions,
  ColDef,
  ITooltipParams,
  GridApi,
  ColumnApi,
  ValueFormatterParams,
  GridReadyEvent,
  ICellRendererParams,
  CellClickedEvent,
  ValueGetterParams,
  CellClassParams
} from '@ag-grid-community/all-modules'

import { KEY_CLASS_YOUBI_TYPE, KEY_CLASS_KYUJITSU_TYPE } from '@/tcw/constant/KeyClass'
import { CodeLabel, ApiGeneralObjectArrayPayload, ApiGeneralSinglePayload } from '@/tcw/api/types'
import { KintaiErrorInfo, TcwAPIDate, TcwFormDate } from '@/tcw/domain/types'
import BaseComponent from '@/tcw/components/BaseComponent'
import GridCellKintaiJikan from '@/components/kintai/molecules/GridCellKintaiJikan.vue'
import GridCellKoutsuhi from '@/components/kintai/molecules/GridCellKoutsuhi.vue'

@Component({
  components: {
    AgGridVue,
    GridCellKintaiJikan,
    GridCellKoutsuhi
  }
})
export default class KintaiListTable extends Mixins(BaseComponent) {
  @Prop({ default: 400 })
  private height!: number
  @Prop({ type: Boolean, default: false })
  private editable!: boolean
  @Prop({ default: () => [] })
  private kintaiList!: ApiGeneralObjectArrayPayload
  // 削除モード受け口（tureのときだけチェック列を出す） issue:724
  @Prop({ type: Boolean, default: false })
  private deleteMode!: boolean

  @Emit()
  private clickDayChienShoumei(_targetDate: TcwAPIDate): void {
    /** */
  }

  private kyujitsuLabelList: CodeLabel[] = []
  private youbiLabelList: CodeLabel[] = []

  private gridApi: GridApi = new GridApi()
  private columnApi: ColumnApi = new ColumnApi()

  private isReady = false

  private get hasError(): boolean {
    return this.kintaiList.some(k => (Array.isArray(k.errorInfo) ? k.errorInfo.length > 0 : false))
  }

  private hasDayError(day: string): boolean {
    const kintai = this.kintaiList.find(k => k.day === day)
    if (kintai == null) return false
    return Array.isArray(kintai.errorInfo) ? kintai.errorInfo.length > 0 : false
  }

  protected created(): void {
    this.beforeProc()
  }
  protected async beforeProc(): Promise<void> {
    // コードラベル情報をSTOREから取得する
    this.kyujitsuLabelList = await this.codeLabel.getCodeLabelList(KEY_CLASS_KYUJITSU_TYPE)
    this.youbiLabelList = await this.codeLabel.getCodeLabelList(KEY_CLASS_YOUBI_TYPE)
    this.isReady = true
  }
  //deleteMode の値が変わった時にこのメソッドが自動で実行される issue:724
  @Watch('deleteMode')
  private onDeleteModeChange(on: boolean): void {
    if (!this.gridApi || !this.columnApi) return
    // 削除列の可視/不可視と行クリック選択の抑止 issue:724
    this.columnApi.setColumnVisible('delete', on)
    ;(this.gridApi as any).setSuppressRowClickSelection?.(on)
    // コンポーネントのレイアウトを再計算・再描画する処理 issue:724
    this.reflowGrid()
    // OFF時は選択解除 issue:724
    if (!on) {
      this.clearSelection()
      ;(this as any).$emit('update:selected-dates', [])
    }
  }

  // 削除呼び出し 内部状態 + UI の選択をクリア isuee:724
  public clearSelection(): void {
    const api: any = this.gridApi
    // gridApiの存在確認
    if (!api) return
    // gridApi は存在しても、再生成・破棄直後などでは
    // forEachNode が未定義になることがあるため、
    // 呼び出し可能かを事前に確認する
    const forEachNode = api.forEachNode
    if (typeof forEachNode !== 'function') return
    // APIを叩いて例外が出ると、タイミング次第でemit/notifyなどの通知処理が止まってしまうため、try/catchで囲って通知処理を継続させる。
    try {
      forEachNode((node: any) => {
        if (node && typeof node.setSelected === 'function') {
          node.setSelected(false)
        }
      })
    } catch (e) {
      console.warn('[clearSelection] failed', e)
    }
  }

  // 行データが変わったら必ず選択状態を捨てる isuee:724
  @Watch('kintaiList')
  onKintaiListChanged(): void {
    this.clearSelection()
  }

  protected getYoubiName(code: string): string {
    const codeLabel = this.youbiLabelList.find((v: CodeLabel) => String(v.code) === code)
    return codeLabel ? codeLabel.label : ''
  }
  protected getKyujitsuName(code: string, record: ApiGeneralSinglePayload): string {
    const codeLabel = this.kyujitsuLabelList.find((v: CodeLabel) => String(v.code) === code)
    const kyujitsuOptionName = (record.kintai as ApiGeneralSinglePayload).kyujitsuOptionName
    return `${codeLabel ? codeLabel.label : ''}${
      kyujitsuOptionName ? '(' + kyujitsuOptionName + ')' : ''
    }`
  }

  get columnDefs(): ColDef[] {
    const defs: ColDef[] = [
      // 削除列を追加 hideで制御 issue:724
      {
        colId: 'delete',
        headerName: '削除',
        width: 72,
        minWidth: 72,
        maxWidth: 72,
        pinned: 'left',
        checkboxSelection: true,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        suppressSizeToFit: true,
        sortable: false,
        resizable: false,
        filter: false,
        hide: !this.deleteMode
      },
      {
        field: 'day',
        headerName: '日付',
        pinned: 'left',
        valueFormatter: (params: ValueFormatterParams) =>
          this.du.convertDateToStr(params.value, 'MM/DD'),
        tooltip: (params: ITooltipParams) => this.du.convertDateToStr(params.value, 'YYYY/MM/DD')
      },
      {
        field: 'kintai.youbiCode',
        headerName: '曜日',
        pinned: this.isMobile ? '' : 'left',
        valueFormatter: (params: ValueFormatterParams) => this.getYoubiName(params.value)
      },
      {
        field: 'kintai.kyujitsuCode',
        headerName: '休日',
        valueFormatter: (params: ValueFormatterParams) =>
          this.getKyujitsuName(params.value, params.data)
      },
      {
        field: 'kintai.kaishi',
        headerName: '開始',
        cellRendererFramework: GridCellKintaiJikan,
        cellRendererParams: (params: ICellRendererParams) => {
          switch (params.data?.kintai?.chikokuCode) {
            case '1':
              return {
                type: 'danger',
                optionString: '遅'
              }
            case '2':
              return {
                type: 'info',
                optionString: '電'
              }
            default:
              return {
                type: 'plain'
              }
          }
        },
        tooltip: (params: ITooltipParams) => {
          let tooltipMessage = ''
          if (params.data?.kintai?.chikokuCode === '2') {
            tooltipMessage = 'クリックで遅延証明書ダウンロード'
          }
          return tooltipMessage
        },
        onCellClicked: (event: CellClickedEvent) => {
          if (event.data?.kintai?.chikokuCode === '2') {
            this.clickDayChienShoumei(event.data.kintai.day)
          }
        },
        cellClass: (params: CellClassParams) => {
          return params.data?.kintai?.chikokuCode === '2' ? 'cell-download' : ''
        }
      },
      {
        field: 'kintai.shuryo',
        headerName: '終了',
        cellRendererFramework: GridCellKintaiJikan,
        cellRendererParams: (params: ICellRendererParams) => {
          switch (params.data?.kintai?.sotaiCode) {
            case '1':
              return {
                type: 'info',
                optionString: '早'
              }
            default:
              return {
                type: 'plain'
              }
          }
        }
      },
      {
        field: 'kintai.gaishutsuJikanTotal',
        headerName: '私用外出',
        valueFormatter: (params: ValueFormatterParams) => this.du.outputHun(params.value, false),
        cellClass: params =>
          this.isZeroAndHasNoDayError(params.value, params.data.day) ? 'cell-text-lightgrey' : '',
        tooltip: (params: ITooltipParams) => {
          const kintai = params.data.kintai
          return kintai.gaishutsuList ? this.tcw.createGaishutsuStr(kintai.gaishutsuList) : ''
        }
      },
      {
        field: 'kintai.kyukei1',
        headerName: '休憩(日中)',
        valueFormatter: (params: ValueFormatterParams) => this.du.outputHun(params.value, false),
        cellClass: params =>
          this.isZeroAndHasNoDayError(params.value, params.data.day) ? 'cell-text-lightgrey' : ''
      },
      {
        field: 'kintai.kyukei2',
        headerName: '休憩(深夜)',
        valueFormatter: (params: ValueFormatterParams) => this.du.outputHun(params.value, false),
        cellClass: params =>
          this.isZeroAndHasNoDayError(params.value, params.data.day) ? 'cell-text-lightgrey' : ''
      },
      {
        field: 'kintai.hushurou',
        headerName: '不就労',
        valueFormatter: (params: ValueFormatterParams) => this.du.outputHun(params.value, false),
        cellClass: params =>
          this.isZeroAndHasNoDayError(params.value, params.data.day) ? 'cell-text-lightgrey' : ''
      },
      {
        field: 'kintai.jikankyu',
        headerName: '時間休',
        valueFormatter: (params: ValueFormatterParams) => this.du.outputHun(params.value, false),
        cellClass: params =>
          this.isZeroAndHasNoDayError(params.value, params.data.day) ? 'cell-text-lightgrey' : ''
      },
      {
        field: 'jikan.jitsudou',
        headerName: '実働',
        valueFormatter: (params: ValueFormatterParams) => this.du.outputHun(params.value, false),
        cellClass: params =>
          this.isZeroAndHasNoDayError(params.value, params.data.day) ? 'cell-text-lightgrey' : ''
      },
      {
        field: 'jikan.jikangai',
        headerName: '時間外',
        valueFormatter: (params: ValueFormatterParams) => this.du.outputHun(params.value, false),
        cellClass: params =>
          this.isZeroAndHasNoDayError(params.value, params.data.day) ? 'cell-text-lightgrey' : ''
      },
      {
        field: 'jikan.shinya',
        headerName: '深夜',
        valueFormatter: (params: ValueFormatterParams) => this.du.outputHun(params.value, false),
        cellClass: params =>
          this.isZeroAndHasNoDayError(params.value, params.data.day) ? 'cell-text-lightgrey' : ''
      },
      {
        field: 'jikan.hounaiJikangai',
        headerName: '法内残業',
        valueFormatter: (params: ValueFormatterParams) => this.du.outputHun(params.value, false),
        cellClass: params =>
          this.isZeroAndHasNoDayError(params.value, params.data.day) ? 'cell-text-lightgrey' : ''
      },
      {
        field: 'koutsuhi.title',
        headerName: '外勤先',
        tooltip: (params: ITooltipParams) => params.value
      },
      {
        field: 'koutsuhi.title',
        headerName: '経路',
        tooltip: (params: ITooltipParams) => {
          const koutsuhi = params.data.koutsuhi
          return koutsuhi?.keiroList ? this.tcw.createKoutsuhiKeiroStr(koutsuhi.keiroList) : ''
        },
        valueGetter: (params: ValueGetterParams) => {
          const koutsuhi = params.data.koutsuhi
          return koutsuhi && koutsuhi.keiroList
            ? this.tcw.createKoutsuhiKeiroStr(koutsuhi.keiroList)
            : ''
        }
      },
      {
        field: 'koutsuhi',
        headerName: '交通費',
        cellRendererFramework: GridCellKoutsuhi
      },
      {
        field: 'kintai.koutsuhiSonota',
        headerName: '交通費(その他)',
        valueFormatter: (params: ValueFormatterParams) =>
          params.value ? `¥${params.value.toLocaleString()}` : ''
      },
      {
        field: 'kintai.gyoumu',
        headerName: '業務内容',
        tooltip: (params: ITooltipParams) => params.value
      },
      {
        field: 'kintai.koutei',
        headerName: '工程',
        tooltip: (params: ITooltipParams) => params.value
      },
      {
        field: 'kintai.kinmuKeitaiName',
        headerName: '勤務形態'
      },
      {
        field: 'kintai.shugyouKeitaiName',
        headerName: '就業形態'
      },
      {
        field: 'kintai.biko',
        headerName: '備考',
        cellClass: 'cell-text-left',
        tooltip: (params: ITooltipParams) => params.value
      }
    ]

    if (this.hasError) {
      defs.push({
        field: 'err',
        headerName: 'エラー',
        cellRenderer: (params: ICellRendererParams) => {
          return params.data.errorInfo && params.data.errorInfo.length > 0
            ? '<a><i class="fas fa-exclamation"></i></a>'
            : ''
        },
        onCellClicked: (event: CellClickedEvent) => {
          if (event.data.errorInfo.length > 0) {
            this.outputErrMessage(event.data.errorInfo)
          }
        }
      })
    }

    if (this.editable) {
      defs.unshift({
        field: 'edit',
        headerName: '修正',
        template: '<a><i class="fas fa-edit"></i></a>',
        onCellClicked: (params: CellClickedEvent) => {
          const targetDate = this.tcw.dateOf(params.data.day)
          this.openEdit(targetDate)
        },
        pinned: 'left'
      })
    }
    return defs
  }

  get gridOptions(): GridOptions {
    return {
      // 常時縦スクロールを表示して幅の基準を固定 issue:724
      alwaysShowVerticalScroll: true,
      // 削除モードなら複数選択、それ以外は単一 issue:724
      rowSelection: 'multiple',
      // 削除モードのときは行クリックで選択しない（チェックのみ）issue:724
      suppressRowClickSelection: this.deleteMode,
      tooltipShowDelay: 300,
      defaultColDef: {
        resizable: true,
        cellStyle: {
          'font-family': '"M PLUS Rounded 1c", sans-serif',
          'font-size': '12px'
        }
      },
      onGridReady: (event: GridReadyEvent) => {
        this.gridApi = event.api
        this.columnApi = event.columnApi
        // 初期の deleteMode に合わせて「削除列」の表示/非表示を同期 issue:724
        this.columnApi.setColumnVisible('delete', this.deleteMode)
        // コンポーネントのレイアウトを再計算・再描画する処理 issue:724
        this.reflowGrid()
        // 行の選択状態が変わったら、選択された行の日付だけを抽出して親へ emit（通知）issue:724
        event.api.addEventListener('selectionChanged', () => {
          // 削除モードOFFのときは常に単一選択にしておく
          if (!this.deleteMode) {
            const selected = event.api.getSelectedNodes?.() || []
            // もし複数選択挙動があれば
            if (selected.length > 1) {
              // 最後に選ばれたものだけ残す
              const last = selected[selected.length - 1]
              this.clearSelection()
              last?.setSelected?.(true)
            }
          }
          const rows = event.api.getSelectedRows() as any[]
          const dates = rows
            .map(r => this.du.convertDateToStr(r?.day, 'YYYY/MM/DD'))
            .map(s => s?.replace(/\//g, '-'))
            .filter(Boolean)
          ;(this as any).$emit('update:selected-dates', dates)
        })
      },
      getRowStyle: (params: {
        data: { kintai: { kyujitsuCode: string }; errorInfo?: KintaiErrorInfo[] }
      }) => {
        if (params.data.errorInfo && params.data.errorInfo.length > 0) {
          const hasError = params.data.errorInfo.some(e => e.code === 'ERROR')
          const hasWarn = params.data.errorInfo.some(e => e.code === 'WARN')
          if (hasError) {
            return { background: '#ff7f50', color: 'white' }
          } else if (hasWarn) {
            return { background: '#f0e68c', color: 'white' }
          }
        }
        if (this.tcw.isHoliday(params.data.kintai.kyujitsuCode)) {
          if (this.tcw.isPublicHoliday(params.data.kintai.kyujitsuCode)) {
            return { background: '#b0c4de' } // 灰色
          } else if (this.tcw.isPrivateHoliday(params.data.kintai.kyujitsuCode)) {
            return { background: '#ffc0cb' } // ピンク
          } else if (this.tcw.isWithoutHoliday(params.data.kintai.kyujitsuCode)) {
            return { background: '#b47142' } // 土色
          } else if (this.tcw.isSpecialHoliday(params.data.kintai.kyujitsuCode)) {
            return { background: '#fedcbd' } // オレンジ
          } else if (this.tcw.isSubstituteHoliday(params.data.kintai.kyujitsuCode)) {
            return { background: '#d2a3cb' } // パープル
          }
        } else if (this.tcw.isNotHoliday(params.data.kintai.kyujitsuCode)) {
          if (this.tcw.isHalfHoliday(params.data.kintai.kyujitsuCode)) {
            return { background: '#ffe6eb' } // 薄いピンク
          } else if (this.tcw.isTransferHolidayOut(params.data.kintai.kyujitsuCode)) {
            return { background: '#e9c6e1' } // 薄いパープル
          } else if (this.tcw.isHolidayWorking(params.data.kintai.kyujitsuCode)) {
            return { background: '#ffedb3' } // 黄色
          } else {
            return { background: '#f0fff0' } //白
          }
        }
      }
    }
  }

  public fit(): void {
    setTimeout(() => this.columnAdjustment(), 200)
  }
  // サイズ調整 isuee:724
  private reflowGrid(): void {
    this.$nextTick(() => {
      this.gridApi?.doLayout?.()
      this.gridApi?.refreshHeader?.()
      this.columnAdjustment()
    })
  }

  public columnAdjustment(): void {
    this.gridApi.sizeColumnsToFit()
    // 日付列の調整
    if (this.columnApi.getColumn('day').getActualWidth() < 70) {
      this.columnApi.setColumnWidth('day', 70)
    }
    //備考列の調整
    this.columnApi.autoSizeColumn('kintai.biko')
    if (
      this.columnApi.getColumn('kintai.biko').getActualWidth() <
      this.columnApi.getColumn('kintai.shugyouKeitaiName').getActualWidth()
    ) {
      this.columnApi.setColumnWidth(
        'kintai.biko',
        this.columnApi.getColumn('kintai.shugyouKeitaiName').getActualWidth() + 25
      )
    } else if (this.columnApi.getColumn('kintai.biko').getActualWidth() < 100) {
      this.columnApi.setColumnWidth('kintai.biko', 100)
    }
  }

  private isZeroAndHasNoDayError(value: number, day: string): boolean {
    return value === 0 && !this.hasDayError(day)
  }

  private openEdit(targetDate: TcwFormDate) {
    if (targetDate) {
      this.$tcw.$store.basic.setTargetDate(targetDate)
      this.$router.push('/kintai/input')
    } else {
      console.warn('指定された日付がnullです')
    }
  }
  private openKoutsuhi(targetDate: Date) {
    this.$tcw.$store.basic.setTargetDate(targetDate)
    this.$router.push('/koutsuhi/input')
  }
  private outputErrMessage(errors: Error[]): void {
    let message = ''
    errors.forEach((err: Error) => {
      message += `<p><i class="fas fa-exclamation-triangle"></i>${err.message}</p>`
    })

    this.$notify.error({
      title: '入力エラー',
      message: message,
      dangerouslyUseHTMLString: true
    })
  }
  private exportCsv() {
    this.gridApi.exportDataAsCsv()
  }
}
